import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import dayjs from 'dayjs'
import { CmsReferralAction } from 'types/cms/collection-types'
import { replaceActiveActionName } from 'lib/cms/referral-actions/utils'
import { IS_PROD } from 'constants/envs'

/**
 * Get the active referral action from the CMS
 *
 * @param {Language} locale
 * @param {string} [replaceNameBy]
 * @returns {Promise<CmsReferralAction | undefined>}
 */
const getActiveReferralAction = async (locale: Language = Language.DUTCH, replaceNameBy?: string): Promise<CmsReferralAction | null> => {
  try {
    // In non-production environments, we can fetch draft referral actions by setting the CMS_FETCH_DRAFTS env var
    const fetchDraft = !IS_PROD && process.env.CMS_FETCH_DRAFTS?.split(',').includes('referral-actions') ? '&status=draft' : ''

    const {
      data: { data }
    } = await axios.get<CMSApiResponseBody<CmsReferralAction[]>>(
      `${process.env.CMS_API_URL}/referral-actions?locale=${locale}${fetchDraft}`
    )

    if (!data) return null

    const today = dayjs()
    const currentlyActiveAction = data.find((action) => today.isBetween(dayjs(action.start).startOf('day'), dayjs(action.end).endOf('day')))

    // Replace the variable {{ name }} in the title & description to match the referrer's first name
    if (replaceNameBy) {
      replaceActiveActionName(currentlyActiveAction, replaceNameBy)
    }

    return currentlyActiveAction || null
  } catch (_) {
    return null
  }
}

export default getActiveReferralAction
